import React from 'react'
import { Button, Table } from 'antd'
import { ListComponent, BaseListComponentProps } from '../BaseComponent'
import { SearchRequest } from '../../services/api/interfaces/ApiRequest'
import { Pagination } from 'components/Pagination'

type InvoiceListProps = BaseListComponentProps & {
  loading: boolean,
  invoices: any,
  pagination: any,
  editing?: any,
  defaultSubmitOptions: any,
  loadInvoices: (args: SearchRequest) => void,
  handleCycleSetPaid: (uuid: string, amount: number) => void
}

export default class InvoiceList extends ListComponent<InvoiceListProps> {

  static defaultProps = {
    loading: false,
    invoices: [],

    loadInvoices: () => { }
  }
/*
  Shelter: json.model.organization.shelter.name
  Gateway: json.model.organization.shelter.payment_gateway_type
  Owner Type: json.model.organization.shelter.payment_owner_type
  Model Type: json.model.organization.shelter.payment_model_type
  Billing amount: json.financial.result.billing_amount
  Payout Status: payout_status_key*/

  tableColumns = [
    {
      title: 'Code',
      dataIndex: 'code',
      key: 'code',
      responsive: ['md'] as any,
      render: (_: string, record: any) => record.code
    },
    {
      title: 'Shelter',
      dataIndex: ['shelter', 'json'],
      key: 'shelter',
      responsive: ['md'] as any,
      render: (_: string, record: any) => {
        console.log(record.json)
        if(!record?.json)return;
        const shelter = record.json.model.organization.shelter.name
        return shelter
      }
    },
    {
      title: 'Gateway',
      dataIndex: 'uuid',
      key: 'uuid',
      responsive: ['md'] as any,
      render: (_: string, record: any) => record.json.model.organization.shelter.payment_gateway_type
    },
    {
      title: 'Owner Type',
      dataIndex: 'ask',
      key: 'ask',
      responsive: ['md'] as any,
      render: (_: string, record: any) => record.json.model.organization.shelter.payment_owner_type
    },
    {
      title: 'Model Type',
      dataIndex: 'position',
      key: 'position',
      responsive: ['md'] as any,
      render: (_: string, record: any) => record.json.model.organization.shelter.payment_model_key
    },
    {
      title: 'Billing amount',
      dataIndex: 'form_tag_key',
      key: 'form_tag_key',
      responsive: ['md'] as any,
      render: (_: string, record: any) => record.json.financial.billing.result.billing_amount
    },
    {
      title: 'Payout Status',
      key: 'payout_status_key',
      responsive: ['md'] as any,
      render: (_: string, record: any) => record.payout_status_key
    },
    {
      title: '',
      key: 'actions',
      responsive: ['md'] as any,
      render: (_: string, record: any) => record.payout_status_key === 'UNPAID' ? <Button type="primary" onClick={() => this.props.handleCycleSetPaid(record.uuid,record.json.financial.result.billing_amount)}>Set Paid</Button> : null
    }
  ]

  protected load() {
    this.searchOptions.search =  {
      payout_status_key: 'UNPAID'
    }

    this.props.loadInvoices(this.searchOptions)
  }


  render() {
    const { loading, pagination, invoices, loadInvoices, defaultSubmitOptions } = this.props

    return (
      <>
        <Table
          loading={loading}
          rowKey='uuid'
          columns={this.tableColumns}
          pagination={false}
          dataSource={invoices}
          onChange={(pagination: any, filters: any, sorter: any) =>
            this.handleTableChange(pagination, sorter, (args) =>
              loadInvoices({
                options: {
                   sort: args.options.sort.length > 0
                    ? args.options.sort
                    : defaultSubmitOptions.options.sort
                },
                search: { ...defaultSubmitOptions.search }
              }))}
        />
        <Pagination
          loading={loading}
          current={pagination?.page}
          pageSize={pagination?.limit}
          length={invoices?.length}
          onChange={(pagination) =>
            this.handleTableChange(
              pagination,
              undefined,
              (args) => {
                console.log(args)
                loadInvoices({
                  options: {
                    ...args.options, sort: args.options.sort.length > 0
                      ? args.options.sort
                      : defaultSubmitOptions.options.sort
                  },
                  search: { ...defaultSubmitOptions.search }
                })
              }
            )
          }
        />
      </>
    )
  }
}
